module.exports = __webpack_public_path__ + "static/media/dashboardChart.3321886b.jpg";